import { ModalForm } from "modules/app/styles"
import { Input, ModalBody } from "reactstrap"
import { StyledSearchInput, CoverImageWrapper } from "./styles"
import { ReactComponent as SearchIcon } from "assets/images/icons/search24.svg"
import { useEffect, useMemo, useState } from "react"
import { createClient } from 'pexels';
import { PageLoader } from "utils/storageUtils"
import debounce from "lodash.debounce";

const Unsplash = ({ handleSubmissionOfMedia, page, setPage }) => {
  const [search, setSearch] = useState('');
  const [unsplashImages, setUnsplashImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true)


  useEffect(() => {
    fetchUnsplashImage(search);
  }, [search, page]);

  useEffect(() => {
    if (page !== 1) {
      setIsLoading(false)
    }
  }, [page]);

  const handleChange = (e) => {
    setIsLoading(true)
    setUnsplashImages([]);

    setTimeout(() => {
      setPage(1)
      setSearch(e.target.value)
    }, 1000)
  };

  const debouncedResults = useMemo(() => {
    return debounce(handleChange, 1000);
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  const fetchUnsplashImage = async searchQuery => {
    setIsLoading(true)
    const client = createClient(process.env.REACT_APP_PEXEL_ACCESS_KEY);

    searchQuery.length ?
      client.photos.search({ query: searchQuery, per_page: 30, page })
        .then(({ photos }) => {
          setUnsplashImages((prevData) => [...prevData, ...photos]);
          setIsLoading(false)
        }) :
      client.photos.curated({ per_page: 30, page })
        .then(({ photos }) => {
          setUnsplashImages((prevData) => [...prevData, ...photos]);
          setIsLoading(false)
        });
  }
  return (
    <>
      <ModalBody>
        <ModalForm>
          <div className='title'>Change Cover Image</div>

          <div className='my-auto d-flex flex-column' style={{ height: '90%' }}>
            <div className='font-weight-600 my-4' style={{ fontSize: '1.14rem' }}>Pexels</div>
          </div>
          <StyledSearchInput>
            <SearchIcon />
            <Input type="text"
              onChange={debouncedResults}

              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                }
              }}
              className="custom-input" placeholder="Search all your images here" />
          </StyledSearchInput>

          <CoverImageWrapper>
            {isLoading ? <div className="d-flex w-100 justify-content-center"><PageLoader /></div> : (unsplashImages?.length ? unsplashImages?.map((image, index) => (
              <img key={image?.id + image?.avg_color + index} onClick={() => handleSubmissionOfMedia(false, image?.src?.portrait)} src={image?.src?.portrait} alt="unsplash" />
            )) : <div className='text-center w-100 p-5'>NO RESULTS FOUND</div>)}
          </CoverImageWrapper>
        </ModalForm>
      </ModalBody>
    </>
  )
}

export default Unsplash